import { createRouter, createWebHistory } from 'vue-router'
import { getEnterpriseId, getToken, isRedirectingToLogin } from '@/utils/auth'
import { useStorage } from '@vueuse/core'
const autoLogin = useStorage('autoLogin', 0)

// 不需要鉴权的公开路由白名单 —— 只能放真正的公开页
const WHITE_LIST = [
  '/login',
  '/inviteMore',
  '/invite',
  '/custom-algorithm',
  '/project-calculation',
  '/enterprise-analytics-screen',
  '/enterpriseLandingPage',
  '/'
]

const routes = [
  // 企业用户
  {
    path: '/my-project',
    component: () => import('@/views/Layout/Index.vue'),
    redirect: '/my-project',
    children: [
      // 我的项目
      {
        path: '/my-project',
        name: 'MyProject',
        component: () => import('@/views/MyProject/Index.vue'),
        meta: {
          keepAlive: false // 需要缓存
        }
      },
      // 系统管理
      {
        path: '/system-company',
        name: 'systemCompany',
        redirect: '/system-company/company-algorithm',
        children: [
          {
            path: '/system-company/company-algorithm',
            name: 'companyAlgorithm',
            component: () =>
              import('@/views/CompanyUser/SystemAdministration/CompanyAlgorithm/Index.vue'),
            meta: {
              keepAlive: true // 需要缓存
            }
          },
          {
            path: '/system-company/team-management',
            name: 'TeamManagementCompany',
            component: () =>
              import('@/views/CompanyUser/SystemAdministration/TeamManagement/Index.vue'),
            meta: {
              keepAlive: false // 需要缓存
            }
          },
          {
            path: '/system-company/project-management',
            name: 'ProjectManagementCompany',
            component: () =>
              import('@/views/CompanyUser/SystemAdministration/ProjectManagement/Index.vue'),
            meta: {
              keepAlive: false // 需要缓存
            }
          },
          {
            path: '/system-company/rule-configuration',
            name: 'RuleConfiguration',
            component: () =>
              import('@/views/CompanyUser/SystemAdministration/RuleConfiguration/Index.vue'),
            meta: {
              keepAlive: false // 需要缓存
            }
          },
          {
            path: '/system-company/operational-logs',
            name: 'OperationalLogs',
            component: () =>
              import('@/views/CompanyUser/SystemAdministration/OperationalLogs/Index.vue'),
            meta: {
              keepAlive: false // 需要缓存
            }
          }
        ]
      },
      // 企业分析
      {
        path: '/enterprise-analytics',
        name: 'EnterpriseAnalytics',
        component: () => import('@/views/EnterpriseAnalytics/Index.vue'),
        meta: {
          keepAlive: false // 需要缓存
        }
      },
      // 项目用户
      {
        path: '/project-user',
        redirect: '/project-user/work-bench',
        children: [
          // 工作台
          {
            path: '/project-user/work-bench',
            name: 'WorkBench',
            component: () => import('@/views/ProjectUser/WorkBench/Index.vue'),
            meta: {
              keepAlive: false // 需要缓存
            }
          },
          {
            path: '/project-user/track-records',
            name: 'TrackRecords',
            component: () => import('@/views/ProjectUser/TrackRecords/Index.vue'),
            meta: {
              keepAlive: false // 需要缓存
            }
          },
          // 系统管理
          {
            path: '/system-administration-project',
            name: 'SystemProject',
            redirect: '/system-project/team-management',
            children: [
              {
                path: '/system-project/team-management',
                name: 'TeamManagementProject',
                component: () =>
                  import('@/views/ProjectUser/SystemProject/TeamManagement/Index.vue'),
                meta: {
                  keepAlive: false // 需要缓存
                }
              },
              {
                path: '/system-project/project-management',
                name: 'ProjectManagementProject',
                component: () =>
                  import('@/views/ProjectUser/SystemProject/ProjectManagement/Index.vue'),
                meta: {
                  keepAlive: false // 需要缓存
                }
              },
              {
                path: '/system-project/node-management',
                name: 'ProjectManagementNode',
                component: () =>
                  import('@/views/ProjectUser/SystemProject/NodeManagement/Index.vue'),
                meta: {
                  keepAlive: false // 需要缓存
                }
              }
            ]
          }
        ]
      }
    ]
  },
  // 登录
  {
    path: '/enterpriseLandingPage',
    redirect: '/login',
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/Index.vue'),
        meta: {
          keepAlive: false // 需要缓存
        }
      }
    ]
  },
  {
    path: '/enterpriseLandingPage',
    redirect: '/inviteMore',
    children: [
      {
        path: '/inviteMore',
        name: 'inviteMore',
        component: () => import('@/views/webInvite/Index.vue'),
        meta: {
          keepAlive: false // 需要缓存
        }
      }
    ]
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/custom-algorithm',
    name: 'CustomAlgorithm',
    component: () => import('@/views/CompanyUser/SystemAdministration/customAlgorithm/Index.vue'),
    meta: {
      keepAlive: false // 需要缓存
    }
  },
  {
    path: '/project-calculation',
    name: 'ProjectCalculation',
    component: () => import('@/components/ProjectCalculation/Index.vue'),
    meta: {
      keepAlive: false // 需要缓存
    }
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/Invite/Index.vue'),
    meta: {
      keepAlive: false // 需要缓存
    }
  },
  {
    path: '/enterprise-analytics-screen',
    name: 'EnterpriseAnalyticsScreen',
    component: () => import('@/views/EnterpriseAnalyticsScreen/Index.vue'),
    meta: {
      keepAlive: false // 需要缓存
    }
  }
]
var buildMode = import.meta.env.VITE_APP_Build_Mode

let base = '/'
if (buildMode === 'dev') {
  base = '/carbonEnterprise/'
}
if (buildMode === 'uat') {
  base = '/carbonEnterprise/'
}
const router = createRouter({
  history: createWebHistory(base),
  routes
})
router.beforeEach(async (to, from, next) => {
  // console.log('router', to, from)
  console.log('mode', buildMode)
  if (to.query.enterpriseId) {
    localStorage.setItem('enterpriseId', to.query.enterpriseId)
    // localStorage.setItem('autoLogin', 1)
    // console.log('登录', autoLogin.value)

    // console.log(getEnterpriseId())
    // to.query.enterpriseId = a
  }
  // if (to.query.inviteId) {
  //   localStorage.setItem('inviteId', to.query.inviteId)
  // }

  // ============ 鉴权守卫 ============
  const token = getToken()
  if (WHITE_LIST.includes(to.path)) {
    // 公开页直接放行，但如果已经登录还跳登录页，直接跳首页
    if (to.path === '/login' && token) {
      next('/my-project')
    } else {
      next()
    }
  } else {
    // 非公开页必须有 token
    if (!token) {
      // 如果 http 拦截器已经在处理 401 跳转，不再重复导航（防死循环）
      if (isRedirectingToLogin || to.path === '/login') {
        next()
      } else {
        next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
      }
    } else {
      next()
    }
  }
})
export default router
